export const PROPOSAL_THEMES = {
  school: {
    key: 'school',
    title: 'Proposte Scuole',
    fontHeading: "'Baloo 2', 'Trebuchet MS', sans-serif",
    fontBody: "'Nunito', 'Segoe UI', sans-serif",
    colors: {
      bg: '#f3fbf6',
      surface: '#ffffff',
      heroStart: '#1f7a4d',
      heroEnd: '#2fa66a',
      accent: '#ffd166',
      accentAlt: '#45d7b0',
      text: '#133826',
      muted: '#4f7764',
      border: '#cfe9da',
    },
  },
  family: {
    key: 'family',
    title: 'Proposte Famiglie',
    fontHeading: "'Fredoka', 'Trebuchet MS', sans-serif",
    fontBody: "'Nunito', 'Segoe UI', sans-serif",
    colors: {
      bg: '#fff8f1',
      surface: '#ffffff',
      heroStart: '#ef476f',
      heroEnd: '#f78c6b',
      accent: '#ffd166',
      accentAlt: '#06d6a0',
      text: '#35131f',
      muted: '#7a4c5f',
      border: '#ffd8de',
      /** titolo header su fondo chiaro: rosa/corallo più chiaro del testo body */
      onLightTitle: '#ee7a9a',
    },
  },
  kids: {
    key: 'kids',
    title: 'Proposte Ragazzi',
    fontHeading: "'Bungee', 'Trebuchet MS', sans-serif",
    fontBody: "'Nunito', 'Segoe UI', sans-serif",
    colors: {
      bg: '#f2fbff',
      surface: '#ffffff',
      heroStart: '#0096c7',
      heroEnd: '#00b4d8',
      accent: '#ffbe0b',
      accentAlt: '#8338ec',
      text: '#10253f',
      muted: '#3d5a80',
      border: '#d0edf8',
      /** titolo header su fondo chiaro: stesso azzurro del gradient hero */
      onLightTitle: '#0096c7',
    },
  },
  adults: {
    key: 'adults',
    title: 'Proposte Adulti',
    fontHeading: "'Space Grotesk', 'Trebuchet MS', sans-serif",
    fontBody: "'Inter', 'Segoe UI', sans-serif",
    colors: {
      bg: '#f5f7fa',
      surface: '#ffffff',
      heroStart: '#1f2937',
      heroEnd: '#374151',
      accent: '#f59e0b',
      accentAlt: '#60a5fa',
      text: '#111827',
      muted: '#4b5563',
      border: '#d1d5db',
    },
  },
  magic: {
    key: 'magic',
    title: 'Proposte Magic & TCG',
    fontHeading: "'Orbitron', 'Trebuchet MS', sans-serif",
    fontBody: "'Rajdhani', 'Segoe UI', sans-serif",
    colors: {
      bg: '#0f1021',
      surface: '#1b1d36',
      heroStart: '#4c1d95',
      heroEnd: '#7c3aed',
      accent: '#22d3ee',
      accentAlt: '#f472b6',
      text: '#f8fafc',
      muted: '#c4b5fd',
      border: '#2f3360',
      /** testo sul pannello bianco delle card (DynamicPropostePubblicheSection) */
      onLightTitle: '#0f1021',
      onLightMuted: '#475569',
    },
  },
};

const DEFAULT_THEME_KEY = 'school';

const FONT_IMPORTS = {
  school:
    'https://fonts.googleapis.com/css2?family=Baloo+2:wght@600;700;800&family=Nunito:wght@400;600;700;800&display=swap',
  family:
    'https://fonts.googleapis.com/css2?family=Fredoka:wght@500;600;700&family=Nunito:wght@400;600;700;800&display=swap',
  kids: 'https://fonts.googleapis.com/css2?family=Bungee&family=Nunito:wght@400;600;700;800&display=swap',
  adults:
    'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap',
  magic:
    'https://fonts.googleapis.com/css2?family=Orbitron:wght@500;700&family=Rajdhani:wght@500;600;700&display=swap',
};

export const resolveProposalThemeKeyFromPath = (pathname = '') => {
  if (pathname.startsWith('/magic-tcg')) return 'magic';
  if (pathname.startsWith('/eventi-adulti')) return 'adults';
  if (pathname.startsWith('/proposte-famiglie')) return 'family';
  if (pathname.startsWith('/proposte-ragazzi')) return 'kids';
  if (
    pathname.startsWith('/proposte-scuole') ||
    pathname.startsWith('/richiesta-scuole')
  ) {
    return 'school';
  }
  return DEFAULT_THEME_KEY;
};

export const resolveProposalTheme = (keyOrPathname) => {
  const candidateKey = PROPOSAL_THEMES[keyOrPathname]
    ? keyOrPathname
    : resolveProposalThemeKeyFromPath(keyOrPathname);
  return PROPOSAL_THEMES[candidateKey] || PROPOSAL_THEMES[DEFAULT_THEME_KEY];
};

export const getThemeFontImport = (themeKey) =>
  FONT_IMPORTS[themeKey] || FONT_IMPORTS[DEFAULT_THEME_KEY];
